import React from 'react'

function ActiveSessionModel({renderForm,isLoading,sessionApiChange}) {
  return (
    <div>   <div
    class="modal fade"
    id="sessionModal"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header p-4">
          <h5 className="mb-0">
            {sessionApiChange == "edit"
              ? "Edit Session"
              : "Add new Session"}
          </h5>
          <button
            type="button"
            class="btn-close"
            id="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body pb-4 px-4">
          {isLoading ? (
            <center>
              <div
                style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
                class="spinner-border mt-3 mb-4"
                role="status"
              />
            </center>
          ) : (
            renderForm()
          )}
        </div>
      </div>
    </div>
  </div></div>
  )
}

export default ActiveSessionModel